import { RESOURCE_USER_DETAILS_ACTION } from './resourceUserDetailsAction';

const resourceUserDetailsReducer = (state, action) => {
  switch (action.type) {
    case RESOURCE_USER_DETAILS_ACTION.GLOBAL_NUDGES_UPDATE_CALLBACK:
      return {
        ...state,
        globalNudges: {
          ...state.globalNudges,
          ...action.globalNudges
        }
      };
    case RESOURCE_USER_DETAILS_ACTION.SET_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: action.snackbarMessage
      };
    default:
      throw new Error(`dispatch action type ${action.type} not recognized`);
  }
};

export default resourceUserDetailsReducer;
